import React, { useEffect, useState } from "react";
import { Row, Col, Typography, Card, Tabs } from "antd";
import styled from "styled-components";
import { getUserList, getUserInfo } from "redux/selectors";
import { bindActionCreators } from "redux";
import { connect, useSelector } from "react-redux";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";

const { Title, Text } = Typography;

const Wrapper = styled.div`
  padding: 24px;
`;

const SideMenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .menu-item {
    padding: 10px 14px;
    border-radius: 8px;
    cursor: pointer;
    color: #374151;
    width: 100%;
    :hover {
      background: #e5e7eb;
    }
  }

  .active {
    background: #d1fae5;
    color: #065f46;
    font-weight: 500;
    width: 100%;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const StatCard = styled(Card)`
  background: #f5f5f5;
  border-radius: 12px;
  border: none;

  .stat-row {
    display: flex;
    justify-content: space-between;
    padding: 12px 0;
    border-bottom: 1px solid #e5e7eb;

    &:last-child {
      border-bottom: none;
    }
  }

  .label {
    color: #111827;
  }

  .value {
    font-weight: 500;
    color: #4b5563;
  }
`;

const IndividualStat = () => {
  const userInfo = useSelector(getUserInfo);
  const [activeTab, setActiveTab] = useState("general");
  const [leaveData, setLeaveData] = useState([]);


  const { key: billingDropdownKey, url: billingDropdownUrl } =
    queryKeys.getIndividualGeneral(`?${`userid=${userInfo.userid}`}`);

  const { data: billingDropdownDataRes, refetch: billingDropdownRefetch } = useFetch(
    billingDropdownKey,
    billingDropdownUrl
  );

  const individualStats = billingDropdownDataRes?.response || {};

  // useEffect(() => {
  //   if (!userInfo?.userid) return;

  //   const fetchLeaveData = async () => {
  //     const res = await CALL_API(
  //       `employee-leave-details/${ClientId}`,
  //       "post",
  //       {
  //         userId: userInfo.userid,
  //         year: new Date().getFullYear(),
  //         requestType: "mine",
  //       }
  //     );

  //     setLeaveData(res || []);
  //   };

  //   fetchLeaveData();
  // }, [userInfo?.userid, ClientId]);

  const getConsumedByCategoryId = (categoryId) => {
    const entry = leaveData.find((item) => item[categoryId]);
    return entry?.[categoryId]?.consumed ?? 0;
  };
  // const leaveStats = leaveCategoryList.map((category) => ({
  //   label: `${category.leave_category_name} Taken`,
  //   value: getConsumedByCategoryId(category.leave_category_id),
  // }));




  const data = [
    {
      label: "Client Survey Average Score",
      // value: individualStats.clientSurveyAvgScore ?? 0,
      value: 9,

    },
    {
      label: "Engagement Appraisal Average",
      // value: individualStats.engagementAppraisalAvgScore ?? 0,
      value: 8.1
    },
    {
      label: "Annual Leaves Taken",
      value: 4,
    },
    {
      label: "Sick Leaves Taken",
      value: 2,
    },

    {
      label: "Chargeability (target to actual %)",
      value: 66,
    },
  ];



  return (
    <Wrapper>
      <Title level={5}>My KPIs</Title>

      <Row gutter={24}>
        {/* Desktop Side Menu */}
        <Col md={5}>
          <SideMenu>
            <div
              className={`menu-item ${activeTab === "general" ? "active" : ""}`}
              onClick={() => setActiveTab("general")}
            >
              General
            </div>
            {/* <div
              className={`menu-item ${activeTab === "timesheet" ? "active" : ""
                }`}
              onClick={() => setActiveTab("timesheet")}
            >
              Timesheet
            </div> */}
          </SideMenu>
        </Col>

        {/* Mobile Tabs */}
        <Col xs={24} md={0}>
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            items={[
              { key: "general", label: "General" },
              { key: "timesheet", label: "Timesheet" },
            ]}
          />
        </Col>

        {/* Content */}
        <Col xs={24} md={19}>
          <StatCard>
            {data.map((item, index) => (
              <div className="stat-row" key={index}>
                <Text className="label">{item.label}</Text>
                <Text className="value">{item.value}</Text>
              </div>
            ))}
          </StatCard>
        </Col>
      </Row>
    </Wrapper>
  );
};

const mapStateToProps = (state) => ({
  userList: getUserList(state),

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {

    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(IndividualStat);
